import React, { useState, useEffect, useRef } from "react"

const VideoPlayer = ({ videoURL }) => {
 

 

  return (
    <div className={`gallery-modal__video-player`}>
      <video className="gallery-item__video" controls>
        <source src={videoURL} type="video/mp4" />
      </video>
    </div>
  )
}

export default VideoPlayer
